import { mainSearch } from "../components/indexDB/indexDBStora";

export const CheckUser = async (code) => {
    const result = {
        data: {},
        status: false,
    }
    if(!code) return result;
    const find = await mainSearch("employees", code);
    if(find) {
        result.data = find;
        result.status = true
        return result;
    }
    else {
        return result;
    }
}